<template>
    <div>

        <el-form ref="form" :model="form" label-width="330px">


  <el-form-item label="User ID,多个ID可以用英文逗号分开"  prop="user" :rules="usersRules">
    <el-input type="textarea" v-model="form.user"   :rows="4"></el-input>
  </el-form-item>
  <el-form-item label="请输入加入白名单的原因描述"  prop="reason" :rules="reasonRules">
    <el-input v-model="form.reason" ></el-input>
  </el-form-item>

  <el-form-item>
    <el-button type="primary" @click="onSubmit">新增白名单</el-button>

  </el-form-item>
</el-form>
    </div>

  </template>
  
  <script>


  export default {

    data() {
      return {
        form: {
          user: '',
          reason: '',
        },
        
      reasonRules: [
        { required: true, message: '加入白名单的原因描述不可为空', trigger: 'blur' }
      ],
      usersRules: [
        { required: true, message: 'ID不可为空,可用英文逗号间隔多个设备', trigger: 'blur' }
      ]

      }
    },
    methods: {
      onSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            // 表单验证通过，执行提交操作
            // 在这里写入提交表单的逻辑

            this.$http.post("/da/add_user_whitelist", this.form).then((response) => {
              location.reload();
              console.log('表单验证通过，可以提交表单');
            })
          } else {
            // 表单验证失败，处理错误
            console.log('表单验证失败');
          }
        });
      }
    }
  }

</script>
 
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  